<div [class.fill]="fill" [class.show]="isLoading" [class.top]="top" class="loading-overlay">
  <mat-progress-bar *ngIf="!uploadProgress" mode="indeterminate"></mat-progress-bar>
  <mat-progress-bar *ngIf="uploadProgress" [value]="uploadProgress" mode="determinate"></mat-progress-bar>
</div>
